export default __webpack_public_path__ + "static/media/shard-relationships.512c08ac.glb";